import { FontConfig } from "../types"

export const BODY_XS_CONFIG: FontConfig = {
  title: "BODY/xs",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 11, tw: "text-[11px]" },
    lineHeight: { px: 15, tw: "leading-[18px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 12, tw: "text-[12px]" },
    lineHeight: { px: 16, tw: "leading-[18px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 13, tw: "text-[13px]" },
    lineHeight: { px: 18, tw: "leading-[18px]" },
  },
}
